// Station Image Service (client)
// Fetches station image URLs via the backend /stationimage endpoint

import { getApi } from './api';

const urlCache = new Map<string, string>();

/**
 * Fetches an image URL for a station from the API (Pixabay, Pexels, Unsplash, Wikipedia).
 */
export async function getStationImageURL(
  stationName: string,
  stationId: string
): Promise<string | null> {
  if (urlCache.has(stationId)) {
    return urlCache.get(stationId) ?? null;
  }

  try {
    const data = await getApi('stationimage', { stationName, stationId }) as { url: string | null };
    const url = data?.url ?? null;
    if (url) {
      urlCache.set(stationId, url);
    }
    return url;
  } catch {
    return null;
  }
}

/**
 * Clears the client-side image URL cache.
 */
export function clearStationImageCache(): void {
  urlCache.clear();
}
